import { Component, OnInit,Input } from '@angular/core';
import { MdDialog, MdDialogRef } from '@angular/material';
import { ApplyStatus } from '../../models/apply-status';
import { ApplyStatusService } from '../../services/apply-status.service';
import { MessageBoxDialog } from '../message-box/message-box.component';

@Component({
  selector: 'app-apply-status',
  templateUrl: './apply-status.component.html',
  styleUrls: ['./apply-status.component.css']
})
export class ApplyStatusComponent implements OnInit {
  publicating: boolean = false;
  applyStatus: ApplyStatus;
  applyStatuses:any;
  @Input() ApplyStatusID;
  @Input() nameComponent;
  @Input() ApplyStatuses;
  errorMessage:string;
  createApplyStatus: boolean = true;

  status=[
    {
      id:1,
      name:'Activo',
    },
    {
      id:0,
      name:'Inactivo',
    },
    {
      id:-6,
      name:'Eliminado',
    }
  ]

  constructor(public dialogRef: MdDialogRef<ApplyStatusComponent>, public applyStatusService: ApplyStatusService, private dialog: MdDialog) { }

  ngOnInit() {
    if (this.nameComponent === "Agregar"){
      this.createApplyStatus = true;
    } else {
      this.createApplyStatus = false;
    }
    this.applyStatus = new ApplyStatus();
    if(this.ApplyStatuses.length > 0){
      //Load data user for ID
      this.applyStatuses = this.ApplyStatuses;
      this.getApplyStatus(this.ApplyStatusID);
    } else {
      this.applyStatuses = new ApplyStatus();
      this.getApplyStatus(1);
    }
  }

  getApplyStatus(id){
    for(let i = 0; i < this.applyStatuses.length; i++){
      if(id === this.applyStatuses[i].id){
        this.applyStatus.id = this.applyStatuses[i].id;
        this.applyStatus.name = this.applyStatuses[i].name;
        this.applyStatus.order = this.applyStatuses[i].order;
        this.applyStatus.status = this.applyStatuses[i].status;
      }
    }
  }

  onApplyStatus(){
    if (this.createApplyStatus) {
      this.onPostApplyStatus();
    } else {
      this.onPutApplyStatus();
    }
  }

  onPutApplyStatus() {
    this.publicating = true;
    this.applyStatusService.putApplyStatus(this.applyStatus)
      .subscribe(
        data => {
          this.applyStatuses = data;
          this.publicating = false;
          this.dialogRef.close('yes');
        },
        error => {
          let err = error;
          this.errorMessage = <any>error;
          this.publicating = false;
          this.dialog.open(MessageBoxDialog, {data: {message: this.errorMessage, alert:false, showIcon:true}});
        }
      );
  }

  onPostApplyStatus() {
    this.publicating = true;
    this.applyStatusService.postApplyStatus(this.applyStatus)
      .subscribe(
        data => {
          this.applyStatuses = data
          this.publicating = false;
          this.dialogRef.close('yes');
        },
        error => {
          let err = JSON.parse(error);
          let err2 = err;
          let txterrors = "";
          console.log(err);
            for( let element in err) {  
              console.log(err2[element]);                                              
                let err: any;
                let txterr: string = "";
                for(let err in err2[element]){
                  txterr = txterr+" "+err2[element][err];
                  console.log(err);
                }
                txterrors = txterrors+", "+txterr;              
            };
          this.errorMessage = <any>error
          this.publicating = false;
          this.dialog.open(MessageBoxDialog, {data: {message: txterrors, alert:true, showIcon:true}});
        }
      );
  }
}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/pages/apply-status/apply-status.component.ts